import React from "react";
import { Search } from "lucide-react";

function AirportOption({ a, active, onPick, onHover }) {
  return (
    <button
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onPick(a.code)}
      onMouseEnter={onHover}
      data-testid="airport-option"
      className={`flex w-full items-center justify-between gap-3 px-3 py-2 text-left ${active ? "bg-blue-50" : "hover:bg-blue-50"}`}
    >
      <span className="min-w-0">
        <span className="block truncate text-sm font-semibold text-slate-900">{a.city}<span className="ml-1.5 font-normal text-slate-500">{a.country}</span></span>
        <span className="block truncate text-xs text-slate-500">{a.name}</span>
      </span>
      <span className="shrink-0 rounded bg-slate-100 px-1.5 py-0.5 text-xs font-bold text-slate-700">{a.code}</span>
    </button>
  );
}

export default function AirportDropdown({ matches, highlighted, customCode, onPick, onHover, testId }) {
  return (
    <div data-testid={testId ? `${testId}-dropdown` : undefined} className="absolute z-30 mt-1 max-h-80 w-full min-w-[280px] overflow-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
      {matches.map((a, i) => (
        <AirportOption key={a.code} a={a} active={i === highlighted} onPick={onPick} onHover={() => onHover(i)} />
      ))}
      {customCode && (
        <button onMouseDown={(e) => e.preventDefault()} onClick={() => onPick(customCode)} data-testid="airport-custom-code" className="flex w-full items-center justify-between border-t border-slate-100 px-3 py-2 text-left hover:bg-blue-50">
          <span className="flex items-center gap-1.5 text-sm text-slate-600"><Search className="h-3.5 w-3.5" /> Search any airport code</span>
          <span className="rounded bg-blue-100 px-1.5 py-0.5 text-xs font-bold text-blue-700">Use {customCode}</span>
        </button>
      )}
    </div>
  );
}
